import axios from 'axios';
import {
    GENAI_GENERATE_REQUEST,
    GENAI_GENERATE_SUCCESS,
    GENAI_GENERATE_FAIL,
    GENAI_JOB_DETAILS_REQUEST,
    GENAI_JOB_DETAILS_SUCCESS,
    GENAI_JOB_DETAILS_FAIL,
    GENAI_MY_JOBS_REQUEST,
    GENAI_MY_JOBS_SUCCESS,
    GENAI_MY_JOBS_FAIL,
    GENAI_TEMPLATES_REQUEST,
    GENAI_TEMPLATES_SUCCESS,
    GENAI_TEMPLATES_FAIL,
    GENAI_DELETE_JOB_REQUEST,
    GENAI_DELETE_JOB_SUCCESS,
    GENAI_DELETE_JOB_FAIL,
    GENAI_STORY_REQUEST,
    GENAI_STORY_SUCCESS,
    GENAI_STORY_FAIL,
    GENAI_APPROVE_STORY_REQUEST,
    GENAI_APPROVE_STORY_SUCCESS,
    GENAI_APPROVE_STORY_FAIL,
    GENAI_REGENERATE_STORY_REQUEST,
    GENAI_REGENERATE_STORY_SUCCESS,
    GENAI_REGENERATE_STORY_FAIL,
    GENAI_IMAGES_REQUEST,
    GENAI_IMAGES_SUCCESS,
    GENAI_IMAGES_FAIL,
    GENAI_REGENERATE_COVER_REQUEST,
    GENAI_REGENERATE_COVER_SUCCESS,
    GENAI_REGENERATE_COVER_FAIL,
    GENAI_APPROVE_PAGES_REQUEST,
    GENAI_APPROVE_PAGES_SUCCESS,
    GENAI_APPROVE_PAGES_FAIL,
    GENAI_REGENERATE_PAGE_REQUEST,
    GENAI_REGENERATE_PAGE_SUCCESS,
    GENAI_REGENERATE_PAGE_FAIL,
    GENAI_APPROVE_FINAL_REQUEST,
    GENAI_APPROVE_FINAL_SUCCESS,
    GENAI_APPROVE_FINAL_FAIL,
    GENAI_RETRY_JOB_REQUEST,
    GENAI_RETRY_JOB_SUCCESS,
    GENAI_RETRY_JOB_FAIL,
} from '../constants/genaiConstants';


const getApiErrorMessage = (error) => {
    const responseData = error.response?.data;

    if (responseData?.detail) {
        return responseData.detail;
    }

    if (responseData?.error) {
        return responseData.error;
    }

    if (responseData && typeof responseData === 'object') {
        return Object.entries(responseData)
            .map(([field, value]) => `${field}: ${Array.isArray(value) ? value.join(', ') : value}`)
            .join(' | ');
    }

    return error.message;
};


// Generate a new personalized book
export const generateBook = (bookData) => async (dispatch, getState) => {
    try {
        dispatch({ type: GENAI_GENERATE_REQUEST });

        const {
            userLogin: { userInfo },
        } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            },
        };

        const { data } = await axios.post(
            '/api/genai/generate/',
            bookData,
            config
        );

        dispatch({
            type: GENAI_GENERATE_SUCCESS,
            payload: data,
        });

    } catch (error) {
        const responseData = error.response?.data;
        let errorMessage = getApiErrorMessage(error);

        if (responseData?.existing_job_id) {
            errorMessage = `${errorMessage} Existing job: ${responseData.existing_job_id}`;
        }

        dispatch({
            type: GENAI_GENERATE_FAIL,
            payload: errorMessage,
        });
    }
};


// Get generation job details
export const getGenaiJobDetails = (jobId) => async (dispatch, getState) => {
    try {
        dispatch({ type: GENAI_JOB_DETAILS_REQUEST });

        const {
            userLogin: { userInfo },
        } = getState();

        const config = {
            headers: {
                Authorization: `Bearer ${userInfo.token}`,
            },
        };

        const { data } = await axios.get(
            `/api/genai/jobs/${jobId}/`,
            config
        );

        dispatch({
            type: GENAI_JOB_DETAILS_SUCCESS,
            payload: data,
        });

    } catch (error) {
        dispatch({
            type: GENAI_JOB_DETAILS_FAIL,
            payload: getApiErrorMessage(error),
        });
    }
};


// Get my generation jobs
export const getMyGenaiJobs = () => async (dispatch, getState) => {
    try {
        dispatch({ type: GENAI_MY_JOBS_REQUEST });

        const {
            userLogin: { userInfo },
        } = getState();

        const config = {
            headers: {
                Authorization: `Bearer ${userInfo.token}`,
            },
        };

        const { data } = await axios.get(
            '/api/genai/jobs/',
            config
        );

        dispatch({
            type: GENAI_MY_JOBS_SUCCESS,
            payload: data,
        });

    } catch (error) {
        dispatch({
            type: GENAI_MY_JOBS_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message,
        });
    }
};


// Get available story templates
export const getStoryTemplates = () => async (dispatch) => {
    try {
        dispatch({ type: GENAI_TEMPLATES_REQUEST });

        const { data } = await axios.get('/api/genai/templates/');

        dispatch({
            type: GENAI_TEMPLATES_SUCCESS,
            payload: data,
        });

    } catch (error) {
        dispatch({
            type: GENAI_TEMPLATES_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message,
        });
    }
};


// Delete generation job
export const deleteGenaiJob = (jobId) => async (dispatch, getState) => {
    try {
        dispatch({ type: GENAI_DELETE_JOB_REQUEST });

        const {
            userLogin: { userInfo },
        } = getState();

        const config = {
            headers: {
                Authorization: `Bearer ${userInfo.token}`,
            },
        };

        await axios.delete(
            `/api/genai/jobs/${jobId}/delete/`,
            config
        );

        dispatch({
            type: GENAI_DELETE_JOB_SUCCESS,
        });

    } catch (error) {
        dispatch({
            type: GENAI_DELETE_JOB_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message,
        });
    }
};


// Get story content for a job
export const getStoryContent = (jobId) => async (dispatch, getState) => {
    try {
        dispatch({ type: GENAI_STORY_REQUEST });

        const {
            userLogin: { userInfo },
        } = getState();

        const config = {
            headers: {
                Authorization: `Bearer ${userInfo.token}`,
            },
        };

        const { data } = await axios.get(
            `/api/genai/jobs/${jobId}/story/`,
            config
        );

        dispatch({
            type: GENAI_STORY_SUCCESS,
            payload: data,
        });

    } catch (error) {
        dispatch({
            type: GENAI_STORY_FAIL,
            payload: getApiErrorMessage(error),
        });
    }
};


// Get images for a job
export const getJobImages = (jobId) => async (dispatch, getState) => {
    try {
        dispatch({ type: GENAI_IMAGES_REQUEST });

        const {
            userLogin: { userInfo },
        } = getState();

        const config = {
            headers: {
                Authorization: `Bearer ${userInfo.token}`,
            },
        };

        const { data } = await axios.get(
            `/api/genai/jobs/${jobId}/images/`,
            config
        );

        dispatch({
            type: GENAI_IMAGES_SUCCESS,
            payload: data,
        });

    } catch (error) {
        dispatch({
            type: GENAI_IMAGES_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message,
        });
    }
};


// Approve story and move to next step
export const approveStory = (jobId) => async (dispatch, getState) => {
    try {
        dispatch({ type: GENAI_APPROVE_STORY_REQUEST });

        const {
            userLogin: { userInfo },
        } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            },
        };

        const { data } = await axios.post(
            `/api/genai/jobs/${jobId}/approve-story/`,
            {},
            config
        );

        dispatch({
            type: GENAI_APPROVE_STORY_SUCCESS,
            payload: data,
        });

    } catch (error) {
        dispatch({
            type: GENAI_APPROVE_STORY_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message,
        });
    }
};


// Regenerate story with feedback
export const regenerateStory = (jobId, feedback) => async (dispatch, getState) => {
    try {
        dispatch({ type: GENAI_REGENERATE_STORY_REQUEST });

        const {
            userLogin: { userInfo },
        } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            },
        };

        const { data } = await axios.post(
            `/api/genai/jobs/${jobId}/regenerate-story/`,
            { feedback },
            config
        );

        dispatch({
            type: GENAI_REGENERATE_STORY_SUCCESS,
            payload: data,
        });

    } catch (error) {
        dispatch({
            type: GENAI_REGENERATE_STORY_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message,
        });
    }
};


// Regenerate cover with feedback
export const regenerateCover = (jobId, feedback) => async (dispatch, getState) => {
    try {
        dispatch({ type: GENAI_REGENERATE_COVER_REQUEST });

        const {
            userLogin: { userInfo },
        } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            },
        };

        const { data } = await axios.post(
            `/api/genai/jobs/${jobId}/regenerate-cover/`,
            { feedback },
            config
        );

        dispatch({
            type: GENAI_REGENERATE_COVER_SUCCESS,
            payload: data,
        });

    } catch (error) {
        dispatch({
            type: GENAI_REGENERATE_COVER_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message,
        });
    }
};


// Approve all pages and move to next step
export const approvePages = (jobId) => async (dispatch, getState) => {
    try {
        dispatch({ type: GENAI_APPROVE_PAGES_REQUEST });

        const {
            userLogin: { userInfo },
        } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            },
        };

        const { data } = await axios.post(
            `/api/genai/jobs/${jobId}/approve-pages/`,
            {},
            config
        );

        dispatch({
            type: GENAI_APPROVE_PAGES_SUCCESS,
            payload: data,
        });

    } catch (error) {
        dispatch({
            type: GENAI_APPROVE_PAGES_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message,
        });
    }
};


// Regenerate specific page with feedback
export const regeneratePage = (jobId, page, feedback) => async (dispatch, getState) => {
    try {
        dispatch({ type: GENAI_REGENERATE_PAGE_REQUEST });

        const {
            userLogin: { userInfo },
        } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            },
        };

        const { data } = await axios.post(
            `/api/genai/jobs/${jobId}/regenerate-page/`,
            { page, feedback },
            config
        );

        dispatch({
            type: GENAI_REGENERATE_PAGE_SUCCESS,
            payload: data,
        });

    } catch (error) {
        dispatch({
            type: GENAI_REGENERATE_PAGE_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message,
        });
    }
};


// Approve final book
export const approveFinal = (jobId) => async (dispatch, getState) => {
    try {
        dispatch({ type: GENAI_APPROVE_FINAL_REQUEST });

        const {
            userLogin: { userInfo },
        } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            },
        };

        const { data } = await axios.post(
            `/api/genai/jobs/${jobId}/approve-final/`,
            {},
            config
        );

        dispatch({
            type: GENAI_APPROVE_FINAL_SUCCESS,
            payload: data,
        });

    } catch (error) {
        dispatch({
            type: GENAI_APPROVE_FINAL_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message,
        });
    }
};


// Retry a failed or stuck generation job
export const retryJob = (jobId) => async (dispatch, getState) => {
    try {
        dispatch({ type: GENAI_RETRY_JOB_REQUEST });

        const {
            userLogin: { userInfo },
        } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            },
        };

        const { data } = await axios.post(
            `/api/genai/jobs/${jobId}/retry/`,
            {},
            config
        );

        dispatch({
            type: GENAI_RETRY_JOB_SUCCESS,
            payload: data,
        });

    } catch (error) {
        dispatch({
            type: GENAI_RETRY_JOB_FAIL,
            payload: getApiErrorMessage(error),
        });
    }
};
